/** @format */

import React, { useEffect } from 'react';
import { Grid, RadioGroup, FormControlLabel, Radio, Typography } from '@mui/material';
import { useStyles } from './style';
import { useFormContext } from 'react-hook-form';
import { InputV2, AutocompleteV, DatePickerPod, Icons, InputCurrency } from 'components';
import { DatePicker } from 'components/LegacyPickers';
import { getDynamicObjectAction, formatPrice } from 'utility';
import clsx from 'clsx';
import CreateDiscountServices from '../../services/CreateDiscountServices';
import useCustomHook from './hooks';
import { RadioButtonIcon, RadioButtonIconFill } from 'components/CheckBox/RadioButtonIcon';
import { useCurrencyUnit } from 'hooks';

const BaseInfo = ({ isFromWallet, setIsFromWallet }) => {
  const {
    guildsList,
    setGuildsList,
    walletsList,
    setWalletsList,
    guildListLoading,
    setGuildListLoading,
  } = useCustomHook();
  const currencyText = useCurrencyUnit(false);

  // -- HOOKS --//
  const methods = useFormContext();
  const classes = useStyles();
  useEffect(() => {
    if (
      (actionsList['AddCreditVouchersSecoundBtn'] && actionsList['AddCreditVouchersBtn']) ||
      actionsList['AddCreditVouchersPage']
    ) {
      setIsFromWallet(false);
    } else if (actionsList['AddCreditVouchersSecoundBtn']) {
      setIsFromWallet(true);
    } else if (actionsList['AddCreditVouchersBtn']) {
      setIsFromWallet(false);
    }
  }, []);

  useEffect(() => {
    if (currencyText) {
      getGuildsList();
    }
  }, [currencyText]);
  const actionsList = getDynamicObjectAction([
    'AddCreditVouchersBtn',
    'AddCreditVouchersSecoundBtn',
    'AddCreditVouchersPage',
  ]);
  useEffect(() => {
    methods.register('guildCode');
    methods.register('expireDate');
    methods.register('wallet');
    return () => {
      methods.unregister('guildCode');
      methods.unregister('expireDate');
      methods.unregister('wallet');
    };
  }, [methods.register, methods.unregister]);

  // -- API REQUESTS --//
  const getGuildsList = async (val = '') => {
    setGuildListLoading(true);

    try {
      const q = { query: encodeURI(val) };
      const result = await CreateDiscountServices.getCreditAccounts(q);
      const guildsData = [...result.result.mainBusinessAmountSrvs];
      const walletsData = [...result.result.customerAmountSrvs];

      if (walletsData.length > 0) {
        let list = [];
        list = walletsData.map((val) => ({
          name: `حساب دیجیتال ${val?.walletName ?? ''} `,
          id: val.id,
          label: `حساب دیجیتال ${val?.walletName ?? ''}`,
          value: val.id,
          code: val?.wallet,
        }));
        setWalletsList(list);
      }

      if (guildsData.length > 0) {
        let list = [];
        list = guildsData.map((val) => ({
          name: `${val?.aliasName ?? val?.guildSrv?.name} (قابل برداشت ${formatPrice(
            val?.withdrawableAmount,
            { currency: currencyText },
          )})`,
          id: val.id,
          label: `${val?.aliasName ?? val?.guildSrv?.name} (قابل برداشت ${formatPrice(
            val?.withdrawableAmount,
            { currency: currencyText },
          )})`,
          value: val.id,
          code: val?.guildSrv?.code,
        }));
        setGuildsList(list);
      }
    } catch (e) {
      console.log('e :', e);
    }

    setGuildListLoading(false);
  };

  return (
    <Grid
      container
      direction="row"
      alignItems="center"
      spacing={2}
      className={classes.root}
      item
      xs={12}
      lg={6}
      md={9}
    >
      <Typography className={classes.bulkFileTitle}>
        <span className={classes.bulkFileIcon}>
          <Icons icon="wallet" color="#ccc" size="20" />
        </span>
        حساب محل بلوکه شدن مبالغ
      </Typography>
      <Grid container spacing={0}>
        <Grid item xs={12}>
          <RadioGroup
            style={{ marginTop: 8, marginInlineStart: 8 }}
            row
            xs={12}
            required
            onChange={(e) => {
              setIsFromWallet(e?.target?.value === 'wallet');
              methods.setValue('guildCode', '');
              if (e?.target?.value === 'wallet') {
                methods.setValue('wallet', '');
                methods.setValue('guildCode', '');
              } else {
                methods.setValue('wallet', '');
                methods.setValue('guildCode', '');
              }
            }}
            value={isFromWallet ? 'wallet' : 'guild'}
            defaultValue="wallet"
          >
            <Grid container xs={12} justifyContent="space-between" spacing={2}>
              {(actionsList['AddCreditVouchersBtn'] || actionsList['AddCreditVouchersPage']) && (
                <Grid item xs={12} md={6}>
                  <FormControlLabel
                    value="guild"
                    className={clsx(classes.radioItem, {
                      active: !isFromWallet,
                    })}
                    control={
                      <Radio
                        className={classes.radioCircle}
                        icon={<RadioButtonIcon />}
                        checkedIcon={<RadioButtonIconFill />}
                      />
                    }
                    label={
                      <>
                        <Typography className={classes.radioText}>حساب‌های تفصیلی</Typography>
                      </>
                    }
                  />
                </Grid>
              )}
              {(actionsList['AddCreditVouchersSecoundBtn'] ||
                actionsList['AddCreditVouchersPage']) && (
                <Grid item xs={12} md={6}>
                  <FormControlLabel
                    value="wallet"
                    className={clsx(classes.radioItem, {
                      active: isFromWallet,
                    })}
                    control={
                      <Radio
                        className={classes.radioCircle}
                        icon={<RadioButtonIcon />}
                        checkedIcon={<RadioButtonIconFill />}
                      />
                    }
                    label={
                      <>
                        <Typography className={classes.radioText}>حساب‌ دیجیتال</Typography>
                      </>
                    }
                  />
                </Grid>
              )}
            </Grid>
          </RadioGroup>
        </Grid>
      </Grid>
      {!isFromWallet ? (
        <Grid item xs={12} md={6}>
          <AutocompleteV
            placeholder="جستجو و انتخاب کنید..."
            control={methods.control}
            errors={methods.formState.errors}
            register={methods.register}
            name="guildCode"
            label="حساب تفصیلی - محل بلوکه شدن مبالغ"
            list={guildsList}
            preventAddCustomOption
            disableClearable
            rules={['required']}
            loading={guildListLoading}
          />
        </Grid>
      ) : null}

      {isFromWallet ? (
        <Grid item xs={12} md={6}>
          <AutocompleteV
            placeholder="جستجو و انتخاب کنید..."
            control={methods.control}
            errors={methods.formState.errors}
            register={methods.register}
            name="wallet"
            label="حساب دیجیتال - محل بلوکه شدن مبالغ"
            list={walletsList}
            preventAddCustomOption
            disableClearable
            rules={['required']}
            loading={guildListLoading}
          />
        </Grid>
      ) : null}
      <Grid item xs={12} md={6}>
        <InputV2
          fullWidth
          label="نام بن"
          errors={methods.formState.errors}
          name="name"
          register={methods.register}
          rules={['required']}
          control={methods.control}
        />
      </Grid>

      <Grid item xs={12}>
        <InputV2
          label="توضیحات"
          multiline
          fullWidth
          rows={3}
          errors={methods.formState.errors}
          name="description"
          register={methods.register}
          rules={['required']}
          control={methods.control}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <InputCurrency
          fullWidth
          label="مبلغ بن شارژ"
          errors={methods.formState.errors}
          name="amount"
          register={methods.register}
          rules={['required', 'isNumeric', 'isMin|0']}
          control={methods.control}
          minimumValue={0}
          decimalPlaces={0}
          englishNumber
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <InputV2
          fullWidth
          label="تعداد بن شارژ قابل صدور"
          errors={methods.formState.errors}
          name="count"
          register={methods.register}
          rules={['required', 'isNumeric', 'isMin|0']}
          control={methods.control}
          currency
          decimalPlaces={0}
          minimumValue={0}
          currencyText="عدد"
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <DatePickerPod label="تاریخ انقضا" showAsterisk>
          <DatePicker
            variant="inline"
            name="expireDate2"
            autoOk
            inputVariant="outlined"
            showTodayButton
            todayLabel="امروز"
            okLabel="تایید"
            cancelLabel="لغو"
            clearLabel="پاک کردن"
            labelFunc={(date) => (date ? date.format('jYYYY/jMM/jDD') : '')}
            value={methods.watch('expireDate')}
            onChange={(e) => methods.setValue('expireDate', e)}
            minDate={new Date()}
          />
        </DatePickerPod>
      </Grid>
    </Grid>
  );
};

export default BaseInfo;
